import React from 'react';
import { FiSearch } from 'react-icons/fi';

import { StatusFilter } from '../../hooks/useCourseListFilter';

import { Container, SearchBox, SearchInput, Select } from './styles';

interface CourseFiltersProps {
  search: string;
  status: StatusFilter;
  onSearchChange: (value: string) => void;
  onStatusChange: (value: StatusFilter) => void;
}

/**
 * Busca e filtro por status da lista de cursos. Ambos atuam no cliente sobre
 * o que já foi carregado (o backend não filtra nem busca).
 */
const CourseFilters: React.FC<CourseFiltersProps> = ({
  search,
  status,
  onSearchChange,
  onStatusChange,
}) => {
  return (
    <Container>
      <SearchBox>
        <FiSearch size={16} aria-hidden />
        <SearchInput
          type="search"
          value={search}
          placeholder="Buscar por título..."
          aria-label="Buscar curso por título"
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </SearchBox>
      <Select
        value={status}
        aria-label="Filtrar por status"
        onChange={(e) => onStatusChange(e.target.value as StatusFilter)}
      >
        <option value="all">Todos os status</option>
        <option value="active">Ativos</option>
        <option value="soon">Em breve</option>
        <option value="inactive">Inativos</option>
      </Select>
    </Container>
  );
};

export default CourseFilters;
